// extracted by mini-css-extract-plugin
export default {"cls1":"bETKFZ0jbSS0T9E4QjDs","cls2":"kp19YXpIuRgqZMOKrGjO bETKFZ0jbSS0T9E4QjDs"};